import React, { useContext } from "react";

import { trans } from "@cortexglobal/rla-intl";
import { RadioField } from "@cortexglobal/rla-components";

import SurveySubmissionContext from "../SurveySubmissionContext";

const AnswerSingle = ({ answer, options, readonly }) => {
    const { surveySystem, handleAnswerChange } = useContext(
        SurveySubmissionContext
    );

    return (
        <RadioField
            name={answer.question_uuid}
            onChange={(e) => handleAnswerChange(e.name, e.value)}
            disabled={!!readonly}
            value={answer.answer}
            options={options.choice}
            error={surveySystem.questionErrors[answer.question_uuid]}
        />
    );
};

export default AnswerSingle;
